'use client';

import { captureAnalyticsEvent } from '@/analytics/analytics-browser';
import { updateGoogleAnalyticsConsent } from '@/analytics/google-analytics-browser';

type AnalyticsEventProperties = Record<string, unknown>;
type AnalyticsConsentState = 'denied' | 'granted';

export function captureAnalyticsClientEvent(
  event: string,
  properties?: AnalyticsEventProperties
) {
  captureAnalyticsEvent(event, properties);
}

export function updateAnalyticsClientConsent(
  analyticsStorage: AnalyticsConsentState
) {
  updateGoogleAnalyticsConsent(analyticsStorage);
}
